module.exports = __webpack_public_path__ + "media/assets/images/category/Weddings@2x-fdfaf8f05a94cc2af59173ed28fff50a.png";